import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import Amount from 'design-system/Amount';
export const AnalyticsCardHeader = ({ title, icon, amount, subTitle, }) => (<>
    <Text Text-16 style={styles.title}>
      {title}
    </Text>
    <View style={styles.subtitleContainer}>
      {icon}
      <Amount value={{
        value: Math.round(amount.amount),
        currency: amount.currency,
    }} NumbersThin-14 Secondary showFraction={false} removeZero/>
      {!!subTitle && (<Text TextThin-14 Secondary>
          {subTitle}
        </Text>)}
    </View>
  </>);
const styles = StyleSheet.create({
    title: {
        marginBottom: rem(4),
    },
    subtitleContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: rem(12),
        alignItems: 'center',
        gap: rem(4),
    },
});
